export const baseRoutes = Object.freeze({
  login: 'login',
  home: '/',
  campaigns: 'campaigns',
  profile: 'profile',
  forgotPassword: 'forgot-password',
  resetPassword: 'reset-password',
  registration: 'registration',
  verification: 'verification',
  interestForm: 'interest-form',
  submissionForm: 'submission-form',
  resources: 'resources',
})

const appRoutes = Object.freeze({
  home: '/',
  pageNotFound: '/page-not-found',
  registration: `/${baseRoutes.registration}`,
  login: `/${baseRoutes.login}`,
  forgotPassword: `/${baseRoutes.forgotPassword}`,
  resetPassword: `/${baseRoutes.resetPassword}`,
  verification: `/${baseRoutes.verification}`,
  campaigns: {
    root: `/${baseRoutes.campaigns}`,
    campaign: `/${baseRoutes.campaigns}/:campaignId`,
    interest: `/${baseRoutes.campaigns}/:campaignId/${baseRoutes.interestForm}`,
    submission: `/${baseRoutes.campaigns}/:campaignId/${baseRoutes.submissionForm}`,
  },
  profile: {
    root: `/${baseRoutes.profile}`,
  },
  resources: {
    root: `/${baseRoutes.resources}`,
  },
})

export default appRoutes
